export class LogoPainter {
    public static paint(canvas: HTMLCanvasElement, instructions: any[]): void {
        let x = 100, y = 100; // Initially give ourselves some room to work with in all directions.
        let penDown = false;
        let direction = 0; // degrees counterclockwise from the x axis (right side).

        // eslint-disable-next-line
        canvas.width = canvas.width;
        const ctx = canvas.getContext('2d') || new CanvasRenderingContext2D(); // FIXME questionable.
        ctx.strokeStyle = "red";

        ctx.moveTo(x, y);

        for (let i = 0; i < instructions.length; i++) {
            const instruction = instructions[i];
            if(instruction.begin || instruction.end) {
            } else if (instruction.pendown) {
                penDown = true;
            } else if (instruction.penup) {
                penDown = false;
            } else if (instruction.move && penDown) {
                ctx.beginPath();
                ctx.moveTo(x, y);

                const directionRadians = direction * Math.PI / 180;
                // console.log("move: ", direction, directionRadians, x, instruction.move[0], Math.cos(directionRadians), instruction.move[0] * Math.cos(directionRadians));
                x += instruction.move[0] * Math.cos(directionRadians);
                y += instruction.move[0] * Math.sin(directionRadians);

                ctx.lineTo(x, y);
                ctx.closePath();
                ctx.stroke();
                // console.log("move/penDown: x, y now", x, y);
            } else if (instruction.move && !penDown) {
                const directionRadians = direction * Math.PI / 180;
                x += instruction.move[0] * Math.cos(directionRadians);
                y += instruction.move[0] * Math.sin(directionRadians);
            } else if (instruction.turn) {
                direction += instruction.turn[0];
            } else {
                console.log("Unknown instruction", instruction);
            }
        }
    }
}

export default LogoPainter;
